import { render } from "./AtSvg.vue?vue&type=template&id=12f816b4"
import script from "./AtSvg.vue?vue&type=script&lang=js"
export * from "./AtSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__